/* RESPONSIBLE TEAM: team-standalone */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class FinStandaloneSetupRoute extends Route {
  @service declare appService: AppService;
  @service declare finStandaloneService: any;
  @service declare store: any;

  async beforeModel() {
    await Promise.all([
      this.store.findRecord('messenger-settings/all', this.appService.app.id),
      this.finStandaloneService.initialize(),
    ]);
  }
}
